<template>
	<div>
		<div v-if="!isShareChatAgency" class="ma-4 text-center">
			Due to unavoidable circumstances we are disabling all offline
			transactions with immediate effect. Any balance which remains in
			retailer wallet will be settled in Distributor's bank account within
			7-10 working days. Please collect your balance from your
			distributor.
		</div>
		<div class="allCenteredChild" v-if="false">
			<img
				:src="
					require(`../../assets/${
						isRummyOptionSelected ? 'jeet11-rummy' : 'jeet11'
					}.png`)
				"
				alt="Logo"
				class="app-logo"
			/>
		</div>
		<target-banner v-if="false" :retailSalaryData="retailSalaryData" />
		<jeet11-target-carousel v-if="false" :transferJeet11="transferJeet11" />
		<jeet11-retailer-banners />
		<div
			v-if="isMojAgency && showAgencyInviteOption"
			class="welcome-message"
		>
			Welcome{{ agencyOwnerName && " " + agencyOwnerName }}!
		</div>

		<!-- <v-card
			v-if="
				(isMojAgency && creditLimit > 0) ||
					(!isMojAgency && isShareChatAgency) ||
					!isShareChatAgency
			"
			tile
			class="top-card"
			:style="{ backgroundColor: themeInputColor }"
		> -->
		<div class="pt-1" v-if="!isShareChatAgency">
			<div>Account Balance</div>
			<div class="amount-wrapper">
				<span class="amount-sign">&#8377;</span>
				<span>{{ jeet11WalletBalance.toLocaleString() }}</span>
			</div>
		</div>
		<!-- <div class="d-flex flex-wrap" v-if="isShareChatAgency">
				<div class="credits-col">
					<div>Current GMV</div>
					<div class="amount-wrapper">
						<span class="amount-sign">&#8377;</span>
						<span>{{ currentGmv }}</span>
					</div>
				</div>
			</div> -->
		<!-- <div
					class="pt-3 d-flex justify-center align-center full-width"
					v-if="!isShareChatAgency"
				>
					<div
						style="width: 50%"
						v-if="retailSalaryData.salaryPayout >= 0"
					>
						<div>Total Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								(
									retailSalaryData.salaryPayout +
									retailSalaryData.bonusPayout
								).toLocaleString()
							}}</span>
						</div>
					</div>
				</div> -->
		<!-- <div
					class="pt-3 d-flex justify-center align-center full-width"
					v-if="retailSalaryData.salaryPayout >= 0"
				>
					<div style="width: 50%">
						<div>Salary Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								retailSalaryData.salaryPayout.toLocaleString()
							}}</span>
						</div>
					</div>
					<div class="vertical-divider" />
					<div style="width: 50%">
						<div>Bonus Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								retailSalaryData.bonusPayout.toLocaleString()
							}}</span>
						</div>
					</div>
				</div> -->
		<div v-if="false" class="pt-3">
			<div>Total Commission Earned (This Month)</div>
			<div class="amount-wrapper">
				<span class="amount-sign">&#8377;</span>
				<span>{{ monthlyCommission.amount.toLocaleString() }}</span>
			</div>
		</div>
		<div v-if="false" class="pt-3">
			<div>
				Gold Membership Commission Earned (This Month)
			</div>
			<div class="amount-wrapper">
				<span class="amount-sign">&#8377;</span>
				<span>{{
					monthlyCommission.premiumCommission.toLocaleString()
				}}</span>
			</div>
		</div>
		<div v-if="false" class="pt-3">
			<div>Referral Earned</div>
			<div class="amount-wrapper">
				<span class="amount-sign">&#8377;</span>
				<span>{{ jeet11TotalReferralEarned.toLocaleString() }}</span>
			</div>
		</div>
		<div v-if="!(isAgency || isMojAgency)" class="pt-4">
			<div
				class="
							d-flex
							justify-start
							blue-grey--text
							text--lighten-3
						"
			>
				Tsm Number
			</div>
			<div class="title d-flex justify-start pt-1">
				{{ tsmNumber }}
			</div>
		</div>
		<!-- </v-card> -->

		<div class="d-flex flex-column ma-1">
			<v-card
				v-if="
					isShareChatAgency && isMojAgency && !!showAgencyInviteOption
				"
				outline
				class="menu-card"
				@click="openInviteList"
			>
				<div>
					Host Invitations
				</div>
				<span class="headline">&#8250;</span>
			</v-card>
			<v-card
				v-if="
					isShareChatAgency && isMojAgency && !!showAgencyInviteOption
				"
				outline
				class="menu-card"
				@click="openHostList"
			>
				<div>
					Host Performance
				</div>
				<span class="headline">&#8250;</span>
			</v-card>
			<v-card
				v-if="false"
				outline
				class="menu-card"
				@click="transferJeet11"
			>
				Transfer To
				{{ isRummyOptionSelected ? "Rummy" : "JEET 11" }}
				User
				<span class="headline">&#8250;</span>
			</v-card>
			<div v-if="(isMojAgency && creditLimit > 0) || !isMojAgency">
				<div class="d-flex justify-space-between align-center mt-1">
					<div class="font-weight-medium" style="font-size: 24px;">
						Recharges
					</div>
					<v-btn
						color="primary"
						class="mr-0 text-none rounded-pill"
						@click="addMoney"
						>+ Recharge Now</v-btn
					>
				</div>
				<div class="tile-container" v-if="isShareChatAgency">
					<v-card class="tile-card">
						<div class="tile-heading">Credit Limit</div>
						<div class="tile-number">
							<span>&#8377;</span>
							<span> {{ getReadableAmount(creditLimit) }}</span>
						</div>
					</v-card>
					<v-card class="tile-card">
						<div class="tile-heading">Credits Left</div>
						<div class="tile-number">
							<span>&#8377;</span>
							<span> {{ getReadableAmount(creditLeft) }}</span>
						</div>
						<div class="tile-subtitle">
							<span>&#8377;</span>
							<span> {{ getReadableAmount(creditUsed) }}</span>
							<span style="color:#a3aed0; font-weight: lighter;"
								>&nbsp;used</span
							>
						</div>
					</v-card>
				</div>
			</div>
			<v-card
				v-if="
					(isMojAgency && creditLimit > 0) ||
						(!isMojAgency && isShareChatAgency)
				"
				outline
				class="menu-card"
				@click="transferCoins"
			>
				<div>
					Transfer To
					{{ isMojAgency ? "Moj" : "ShareChat" }} User
				</div>
				<span class="headline">&#8250;</span>
			</v-card>
			<v-card
				v-if="(isMojAgency && creditLimit > 0) || !isMojAgency"
				outline
				class="menu-card"
				@click="openPassbook"
			>
				<div>Passbook</div>
				<span class="headline">&#8250;</span>
			</v-card>

			<v-card
				v-if="(isMojAgency && creditLimit > 0) || !isMojAgency"
				outline
				class="menu-card"
				@click="openInvoiceNumber"
			>
				Invoice Numbers

				<span class="headline">&#8250;</span>
			</v-card>

			<v-card
				v-if="false"
				outline
				class="menu-card"
				@click="openReferralModal"
			>
				<div>
					Invite
					{{ isRummyOptionSelected ? "Rummy" : "JEET 11" }}
					User
				</div>
				<span class="headline">&#8250;</span>
			</v-card>
			<v-card
				v-if="false"
				outline
				class="menu-card"
				@click="inviteRetailer"
			>
				<div>
					Invite
					{{ isJeet11Captain ? "Captain" : "Retailer" }}
				</div>
				<span class="headline">&#8250;</span>
			</v-card>
		</div>

		<v-dialog width="600px" persistent v-model="referralModal">
			<div class="white pos-rel rounded-lg">
				<div class="px-0 card-header">
					<div>Invite Jeet11 User</div>
				</div>
				<div class="top-right-align ma-0 pa-0">
					<v-btn @click="closeReferralModal" fab flat>
						<v-icon>close</v-icon>
					</v-btn>
				</div>
				<div class="pa-4">
					<v-text-field
						label="Phone Number"
						v-model="jeet11UserPhoneNo"
						placeholder="Enter Phone Number"
						class="text-field-wrapper pt-4"
						prepend-icon="phone"
						@keyup.enter="inviteJeet11User"
						:rules="[requiredRule, onlyDigitRule]"
						maxlength="10"
					></v-text-field>
					<div class="d-flex pt-3">
						<v-btn
							:color="themeInputColor"
							class="white--text btn py-4"
							@click="inviteJeet11User"
							:disabled="
								/\D/g.test(jeet11UserPhoneNo) ||
									jeet11UserPhoneNo.length !== 10
							"
							>INVITE
						</v-btn>
					</div>
				</div>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="addMoneyDialogBox">
			<div class="white pos-rel rounded-lg" v-if="addMoneyDialogBox">
				<div class="top-right-align pa-0 ma-n1">
					<v-btn @click="addMoneyDialogBox = false" fab flat>
						<v-icon>close</v-icon>
					</v-btn>
				</div>
				<add-money
					@ADD_MONEY="initiateAddMoney"
					:isLoading="initiatingAddMoney"
					:checkingStatus="checkingPaymentStatus"
					:isRummyOptionSelected="isRummyOptionSelected"
					:themeInputColor="themeInputColor"
					:creditUsed="creditUsed"
					:isShareChatAgency="isShareChatAgency"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="inviteRetailerDialog">
			<div class="white pos-rel rounded-lg" v-if="inviteRetailerDialog">
				<invite-retailer
					:partnerType="invitePartnerType"
					:partnerPhoneNo="jeet11PartnerPhoneNo"
					:themeInputColor="themeInputColor"
					@CLOSE_MODAL="closeModal"
					model="inviteRetailerDialog"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="transferJeet11Dialog">
			<div>
				<transfer-money
					model="transferJeet11Dialog"
					:themeInputColor="themeInputColor"
					:searchingJeet11User="searchingJeet11User"
					:searchedUser="jeet11User"
					:payingJeet11User="pay11Jeet11UserLoading"
					:forgetMpin="forgetMpin"
					:jeet11WalletBalance="jeet11WalletBalance"
					@SEARCH_USER="searchJeet11User"
					@CLOSE_MODAL="closeModal"
					@RESET_SEARCHED_JEET11_USER="resetJeet11SearchedUser"
					@CONFIRM_AND_PAY_TO_JEET11_USER="confirmAndPayJeet11User"
					:isRummyOptionSelected="isRummyOptionSelected"
				/>
			</div>
		</v-dialog>
		<v-dialog
			width="600px"
			fullscreen
			hide-overlay
			v-model="transferCoinsDialog"
		>
			<div>
				<transfer-coins
					model="transferCoinsDialog"
					:themeInputColor="themeInputColor"
					:payingUser="payingCoinsLoading"
					:forgetMpin="forgetMpin"
					:jeet11WalletBalance="jeet11WalletBalance"
					@CLOSE_MODAL="closeModal"
					@CONFIRM_AND_PAY_TO_JEET11_USER="confirmPaySharechatCoins"
					:sharechatProducts="sharechatProducts"
					:triggerTransferCoinDataReset="triggerTransferCoinDataReset"
					:isShareChatAgency="isShareChatAgency"
					:isMojAgency="isMojAgency"
					:creditLeft="creditLeft"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" fullscreen v-model="tableDialog">
			<template v-if="tableDialog">
				<invitation-table
					@CLOSE_MODAL="closeModal"
					model="tableDialog"
					:themeColor="themeInputColor"
					:agencyId="showAgencyInviteOption"
				/>
			</template>
		</v-dialog>

		<v-dialog width="600px" fullscreen v-model="hostDialog">
			<template v-if="hostDialog">
				<host-performance
					@CLOSE_MODAL="closeModal"
					model="hostDialog"
					:themeColor="themeInputColor"
					:agencyId="showAgencyInviteOption"
				/>
			</template>
		</v-dialog>

		<v-dialog width="600px" fullscreen v-model="invoiceNumberDialog">
			<template v-if="invoiceNumberDialog">
				<invoice-number
					@CLOSE_MODAL="closeModal"
					model="invoiceNumberDialog"
					:themeColor="themeInputColor"
					:agencyId="showAgencyInviteOption"
				/>
			</template>
		</v-dialog>

		<generate-mpin
			@CLOSE_MODAL="closeModal"
			model="generateMpinDialog"
			v-if="generateMpinDialog"
			:themeInputColor="themeInputColor"
		/>
		<passbook-view
			@LOAD_MORE_ROWS="fetchJeet11TransactionsHistory({ type: END })"
			@CLOSE_MODAL="closeModal"
			:data="
				isRummyOptionSelected
					? rummyPartnerTransaction
					: jeet11PartnerTransactions
			"
			:loading="fetchingTransactions"
			model="passbookDialog"
			v-if="passbookDialog"
			:themeInputColor="themeInputColor"
		/>
		<v-dialog width="600px" persistent v-model="editTsmDialog">
			<div class="white pos-rel rounded-lg" v-if="editTsmDialog">
				<edit-tsm-number
					:themeInputColor="themeInputColor"
					@CLOSE_MODAL="closeModal"
					@fetchJeet11WalletDetails="fetchJeet11WalletDetails"
					model="editTsmDialog"
				/>
			</div>
		</v-dialog>
		<v-dialog v-model="showTransactionCard" width="500">
			<v-card class="transaction-card">
				<div class="header success" v-if="isCoinTransferSuccessful">
					Transfer Successful
				</div>
				<div class="header failure" v-else>Transfer Failed</div>
				<div class="bottom-part">
					<div>{{ transferCoinsUserData.name }}</div>
					<div>
						{{ transferCoinsUserData.handle }}
					</div>
					<div>Ph: {{ transferCoinsUserData.phoneNo }}</div>
					<div>
						{{ totalCoinsTransferred }}
						{{ isMojAgency ? "Cheers" : "Coins" }}
					</div>
					<v-btn color="primary" @click="showTransactionCard = false">
						Done
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog
			v-if="isJeet11Promoter && isInShopType"
			width="600px"
			persistent
			v-model="showPromoterMappingModal"
		>
			<div
				class="white pos-rel rounded-lg"
				v-if="showPromoterMappingModal"
			>
				<promoter-mapping-modal
					@fetchJeet11WalletDetails="fetchJeet11WalletDetails"
				/>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import ApiService from "@/store/api-service";
import {
	BASE_URL,
	MOJ_TOOLS_BASE_URL,
	MOJ_TOOLS_ACCESS_TOKEN
} from "../../../config";
import { mapState, mapGetters } from "vuex";
import * as utils from "@/utils";
import {
	INITIATE_PAYMENT,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_JEET11_USER_BY_PHONE,
	FETCH_JEET11_PARTNER_TRANSACTION_HISTORY,
	RESET_JEET11_SEARCHED_USER,
	// JEET11_PAYMENT_SEND_OTP,
	PAY_JEET11_USER,
	CHECK_PAYMENT_STATUS,
	SHOW_ALERT,
	FETCH_MONTHLY_COMMISSION,
	TRANSFER_COINS
} from "@/store/action-types";
import { END } from "@/store/config";
import AddMoney from "./add-money";
import TransferMoney from "./transfer-money";
import TransferCoins from "./transfer-coins";
import HostPerformance from "./host-performance.vue";
import InvitationTable from "./invitation-table.vue";
import { TOP } from "@/store/config";
import GenerateMPIN from "../GenerateMPIN";
import Jeet11RetailBanners from "../jeet11-retail-banners";
import InviteRetailer from "../Jeet11Distributor/invite-retailer";
import Jeet11TargetCarousel from "../Jeet11TargetCarousel";
import PassbookView from "@/components/passbook-view";
import InvoiceNumber from "../AgencyInvoiceNumbers";
import { shareOnWhatsapp } from "@/utils";
import EventsManager from "@/event-manager";
import EditTsmNumber from "../EditTsmNumber/edit-tsm-number";
import TargetBanner from "../TargetBanner";
import PromoterMappingModal from "./promoter-mapping-modal.vue";
import {
	ADD_MONEY,
	FETCH_RETAIL_SALARY,
	SET_AGENCY_DATA,
	SET_PAGE_HEADER_LOGO,
	UPDATE_PAGE_TITLE
} from "../../store/action-types";
import {
	FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY,
	PAY_RUMMY_USER
} from "../../store/action-types";
import { RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../constants";
import { getReadableAmount } from "../../utils";

export default {
	name: "JEET11",
	data() {
		return {
			END,
			amount: null,
			tab: 0,
			addMoneyDialogBox: false,
			inviteRetailerDialog: false,
			items: [
				{
					name: "Add Money",
					key: "addMoney",
					component: AddMoney
				},
				{
					name: "Transactions",
					key: "transactions"
				},
				{
					name: "Pay to JEET 11 user",
					key: "transferMoney"
				}
			],
			headers: [
				{
					text: "Time",
					value: "createdOn",
					align: "center",
					sortable: false
				},
				{
					text: "Name",
					value: "name",
					align: "center",
					sortable: false
				},
				{
					text: "Amount",
					value: "amount",
					align: "center",
					sortable: false
				},
				{
					text: "Mode",
					value: "mode",
					align: "center",
					sortable: false
				},
				{
					text: "Txn ID",
					value: "transactionId",
					align: "center",
					sortable: false
				},
				{
					text: "ID",
					value: "id",
					align: "center",
					sortable: false
				}
			],
			fetchingTransactions: false,
			searchingJeet11User: false,
			initiatingAddMoney: false,
			pay11Jeet11UserLoading: false,
			transferJeet11Dialog: false,
			transferCoinsDialog: false,
			tableDialog: false,
			hostDialog: false,
			passbookDialog: false,
			generateMpinDialog: false,
			checkingPaymentStatus: false,
			intervalForPaymentStatus: null,
			referralModal: false,
			jeet11UserPhoneNo: null,
			fetchingMonthlyCommission: false,
			fetchingProducts: false,
			payingCoinsLoading: false,
			editTsmDialog: false,
			showTransactionCard: false,
			isCoinTransferSuccessful: false,
			totalCoinsTransferred: null,
			triggerTransferCoinDataReset: false,
			requiredRule: v => utils._requiredRule(v),
			onlyDigitRule: v => utils._onlyDigitsRule(v),
			retailSalaryData: {},
			appToggle: 0,
			currentGmv: 0,
			showAgencyInviteOption: "",
			agencyOwnerName: "",
			getReadableAmount,
			invoiceNumberDialog: false
		};
	},
	components: {
		"add-money": AddMoney,
		"transfer-money": TransferMoney,
		"generate-mpin": GenerateMPIN,
		"jeet11-retailer-banners": Jeet11RetailBanners,
		"invite-retailer": InviteRetailer,
		"passbook-view": PassbookView,
		"jeet11-target-carousel": Jeet11TargetCarousel,
		"transfer-coins": TransferCoins,
		"host-performance": HostPerformance,
		"edit-tsm-number": EditTsmNumber,
		"target-banner": TargetBanner,
		"promoter-mapping-modal": PromoterMappingModal,
		"invitation-table": InvitationTable,
		"invoice-number": InvoiceNumber
	},
	mounted() {
		this.fetchJeet11WalletDetails();
		this.resetJeet11SearchedUser();
		// this.fetchMonthlyCommission();
		if (this.isJeet11Promoter) {
			this.fetchRetailSalary();
		}
		if (this.$route.query.orderId) {
			this.startIntervalForCheckingStatus(this.$route.query.orderId);
		}
		if (this.$route.query.razorpayCallback) {
			this.processPayment(this.$route.query.razorpayCallback);
		}
		if (this.isRummyOptionSelected) {
			this.appToggle = 1;
		}
		if (this.isShareChatAgency) {
			this.getAgencyCurrentGmv();
		}
		if (this.isShareChatAgency && this.isMojAgency) {
			this.getAgencyInviteAccess();
		}
	},

	beforeDestroy() {
		clearInterval(this.intervalForPaymentStatus);
	},

	computed: {
		...mapState({
			jeet11PartnerTransactions: state =>
				state.jeet11.jeet11PartnerTransactionHistory,
			jeet11WalletBalance: state =>
				state.jeet11.jeet11PartnerDetails.walletBalance || 0,
			jeet11TotalReferralEarned: state =>
				state.jeet11.jeet11PartnerDetails.referralEarning || 0,
			jeet11PartnerPhoneNo: state =>
				state.jeet11.jeet11PartnerDetails.phoneNo || "",
			jeet11User: state => state.jeet11.jeet11User,
			userId: state => state.auth.USERID,
			userData: state => state.user.userData,
			monthlyCommission: state => state.jeet11.monthlyCommission,
			sharechatProducts: state => state.jeet11.sharechatProducts,
			promoterMonthlyCommission: state =>
				state.jeet11.promoterMonthlyCommission,
			isAgency: state =>
				state.jeet11.jeet11PartnerDetails.shopType === "agency",
			isMojAgency: state =>
				state.jeet11.jeet11PartnerDetails.shopType === "agency_moj",
			isScAgency: state =>
				state.jeet11.jeet11PartnerDetails.shopType === "agency",
			tsmNumber: state =>
				state.jeet11.jeet11PartnerDetails.tsmNumber || "_________",
			transferCoinsUserData: state => state.jeet11.transferCoinsUserData,
			showPromoterMappingModal: state =>
				state.jeet11.jeet11PartnerDetails.retailerMappedId === null,
			rummyPartnerTransaction: state =>
				state.rummy.rummyPartnerTransactionHistory,
			creditLimit: state =>
				state.jeet11.jeet11PartnerDetails.creditLimit || 0,
			creditUsed: state =>
				state.jeet11.jeet11PartnerDetails.creditUsed || 0,
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		isSmallScreen() {
			return this.$vuetify.breakpoint.name === "xs";
		},
		...mapGetters({
			isJeet11Captain: "auth/isJeet11Captain",
			isJeet11Retailer: "auth/isRetailer",
			isJeet11Promoter: "auth/isJeet11Promoter",
			isInShopType: "jeet11/isInShopType"
		}),
		invitePartnerType() {
			return this.isJeet11Captain ? "captain" : "retailerInvite";
		},
		isShareChatAgency() {
			return this.isJeet11Captain && (this.isAgency || this.isMojAgency);
		},
		themeInputColor() {
			return this.isRummyOptionSelected
				? RUMMY_COLOUR
				: THEME_INPUT_COLOUR;
		},
		creditLeft() {
			return this.creditLimit - this.creditUsed;
		},
		isMojAgencyCombinedCheck() {
			return `${this.isShareChatAgency}|${this.isMojAgency}`;
		}
	},
	props: ["isRummyOptionSelected"],
	methods: {
		async getAgencyCurrentGmv() {
			try {
				const date = new Date();
				const payload = {
					access_token: this.ACCESS_TOKEN,
					params: {
						month: date.getMonth() + 1,
						year: date.getFullYear()
					}
				};
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getRetailerGmv`;
				const response = await ApiService.post(endpoint, payload);
				const { response: data, statusCode } = response;
				if (statusCode === 200) {
					this.currentGmv = data.gmv;
				}
			} catch (e) {
				this.showAlert(e.message);
			}
		},
		async getAgencyInviteAccess() {
			try {
				const loginPhoneNumber = String(
					this.jeet11PartnerPhoneNo
				).substring(2);
				const headers = {
					"X-SHARECHAT-ACCESS-TOKEN": MOJ_TOOLS_ACCESS_TOKEN
				};
				const endpoint = `${MOJ_TOOLS_BASE_URL}/livestream-tools-service/v1/internal/agencies?phoneNumber=${loginPhoneNumber}&status=ACTIVE`;
				const response = await ApiService.get(endpoint, headers);
				if (Array.isArray(response) && response.length > 0) {
					this.showAgencyInviteOption = response[0].agencyId;
					this.agencyOwnerName = response[0].ownerName;
					this.$store.dispatch(SET_AGENCY_DATA.dispatch, response[0]);
				} else {
					this.showAgencyInviteOption = "";
					this.agencyOwnerName = "";
					this.$store.dispatch(SET_AGENCY_DATA.dispatch, null);
				}
			} catch (e) {
				this.showAlert(e.message);
				this.showAgencyInviteOption = "";
				this.agencyOwnerName = "";
				this.$store.dispatch(SET_AGENCY_DATA.dispatch, null);
			}
		},
		addMoney() {
			this.addMoneyDialogBox = true;
		},
		inviteRetailer() {
			this.inviteRetailerDialog = true;
		},
		transferJeet11() {
			this.transferJeet11Dialog = true;
		},
		transferCoins() {
			this.transferCoinsDialog = true;
		},
		openInviteList() {
			this.tableDialog = true;
		},
		openHostList() {
			this.hostDialog = true;
		},
		openInvoiceNumber() {
			this.invoiceNumberDialog = true;
		},
		openPassbook() {
			this.passbookDialog = true;
			this.fetchJeet11TransactionsHistory({ type: TOP });
		},
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true,
					isCardGame: this.isRummyOptionSelected ? 1 : 0
				})
				.catch(() => {})
				.then(() => {
					if (this.isMojAgency) {
						this.setHeaderLogo(
							"https://cdn-sc-g.sharechat.com/33d5318_1c8/live/1eca8524_1737723683002_sc.png"
						);
					} else if (this.isScAgency) {
						this.setHeaderLogo(
							"https://cdn-sc-g.sharechat.com/33d5318_1c8/live/25efa7ce_1737723689014_sc.png"
						);
					} else {
						this.setHeaderLogo(null);
						this.updatePageTitle("ShareChat | Moj");
					}
				});
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		updatePageTitle(pageTitle) {
			this.$store.dispatch(UPDATE_PAGE_TITLE.dispatch, {
				name: pageTitle
			});
		},
		setHeaderLogo(logoUrl) {
			this.$store.dispatch(SET_PAGE_HEADER_LOGO.dispatch, logoUrl);
		},
		editTsmNumber() {
			this.editTsmDialog = true;
		},
		initiateAddMoney(amount) {
			if (!this.initiatingAddMoney) {
				this.initiatingAddMoney = true;
				this.$store
					.dispatch(INITIATE_PAYMENT.dispatch, {
						amount: Number(amount),
						walletCategory: this.isRummyOptionSelected
							? "games"
							: null
					})
					.finally(() => {
						this.initiatingAddMoney = false;
						this.addMoneyDialogBox = false;
					});
			}
		},
		processPayment(razorpayCallback) {
			const parsedData = JSON.parse(razorpayCallback);
			const { data, status } = parsedData;
			if (status === "failure") {
				this.showAlert("Payment failed, please try again!");
				this.$router.replace({ razorpayCallback: null });
				return;
			}
			this.checkingPaymentStatus = true;
			this.addMoneyDialogBox = true;
			this.$store
				.dispatch(ADD_MONEY.dispatch, {
					...data
				})
				.then(response => {
					const { msg } = response;
					if (msg === "Success") {
						this.showAlert(
							"Payment Complete, amount will be added in your account soon!"
						);
					}
					this.checkingPaymentStatus = false;
					this.addMoneyDialogBox = false;
					this.fetchJeet11WalletDetails();
					this.$router.replace({ razorpayCallback: null });
				})
				.catch(() => {
					this.checkingPaymentStatus = false;
					this.addMoneyDialogBox = false;
					this.showAlert("Payment is not confirmed!");
					this.$router.replace({ razorpayCallback: null });
				});
		},
		startIntervalForCheckingStatus(orderId) {
			const times = 150; // 2m 30s
			let current = 0;
			this.intervalForPaymentStatus = setInterval(() => {
				if (current === times) {
					this.addMoneyDialogBox = false;
					clearInterval(this.intervalForPaymentStatus);
					this.showAlert("Payment is not confirmed!");
					this.checkingPaymentStatus = false;
				} else if (current % 5 === 0) {
					this.checkForPaymentStatus(orderId);
				}
				current++;
			}, 1000);
		},
		checkForPaymentStatus(orderId) {
			this.initiatingAddMoney = false;
			this.checkingPaymentStatus = true;
			this.$store
				.dispatch(CHECK_PAYMENT_STATUS.dispatch, {
					orderId,
					mode: "razorpay"
				})
				.then(({ status }) => {
					if (status === "success" || status === "failed") {
						this.checkingPaymentStatus = false;
						this.showAlert(
							status === "success"
								? "Payment Success!"
								: "Payment Failed!"
						);
						clearInterval(this.intervalForPaymentStatus);
						this.addMoneyDialogBox = false;
						this.fetchJeet11WalletDetails();
						this.$router.replace({ query: null });
					}
				})
				.catch(() => {
					this.checkingPaymentStatus = false;
					this.addMoneyDialogBox = false;
					clearInterval(this.intervalForPaymentStatus);
					this.showAlert("Payment is not confirmed!");
					this.$router.replace({ query: null });
				});
		},
		searchJeet11User(payload) {
			if (!this.searchingJeet11User) {
				this.searchingJeet11User = true;
				this.$store
					.dispatch(FETCH_JEET11_USER_BY_PHONE.dispatch, payload)
					.catch(() => {})
					.then(() => (this.searchingJeet11User = false));
			}
		},
		fetchJeet11TransactionsHistory(payload) {
			payload.userId = this.userId;
			if (!this.fetchingTransactions) {
				this.fetchingTransactions = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY.dispatch
							: FETCH_JEET11_PARTNER_TRANSACTION_HISTORY.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingTransactions = false;
					});
			}
		},
		resetJeet11SearchedUser() {
			this.$store.dispatch(RESET_JEET11_SEARCHED_USER.dispatch);
		},
		confirmAndPayJeet11User(payload) {
			if (!this.pay11Jeet11UserLoading) {
				this.pay11Jeet11UserLoading = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? PAY_RUMMY_USER.dispatch
							: PAY_JEET11_USER.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.pay11Jeet11UserLoading = false;
						this.transferJeet11Dialog = false;
						this.fetchJeet11WalletDetails();
					});
			}
		},
		confirmPaySharechatCoins(payload) {
			if (!this.payingCoinsLoading) {
				this.payingCoinsLoading = true;
				const selectedProduct = this.sharechatProducts.filter(
					product => product.productId === payload.productId
				);
				let productIdToUse = payload.productId;
				if (
					selectedProduct[0] &&
					selectedProduct[0].offers &&
					selectedProduct[0].offers.length > 0
				) {
					const offer = selectedProduct[0].offers[0];
					const offerData = selectedProduct[0].offersData[offer];
					productIdToUse =
						offerData.vendorProducts.RZPAY.vendorProductId;
				}
				this.totalCoinsTransferred =
					(this.isMojAgency
						? selectedProduct[0].creditAmount
						: selectedProduct[0].virtualCurrencyValue) *
					payload.quantity;
				const { userId, phone, ...restPayload } = payload;
				const finalPayload = {
					...restPayload,
					productId: productIdToUse,
					...(this.isMojAgency ? { userId } : { phone })
				};
				this.$store
					.dispatch(TRANSFER_COINS.dispatch, finalPayload)
					.catch(() => {
						this.isCoinTransferSuccessful = false;
					})
					.then(isSuccess => {
						this.payingCoinsLoading = false;
						this.transferCoinsDialog = false;
						this.fetchJeet11WalletDetails();
						if (isSuccess) this.isCoinTransferSuccessful = true;
						else this.isCoinTransferSuccessful = false;
					})
					.finally(() => {
						this.showTransactionCard = true;
						this.triggerTransferCoinDataReset = !this
							.triggerTransferCoinDataReset;
					});
			}
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		closeModal(payload) {
			this[payload] = false;
		},
		isMobileResolution() {
			return this.$vuetify.breakpoint.width < 600;
		},
		openReferralModal() {
			this.referralModal = true;
		},
		closeReferralModal() {
			this.jeet11UserPhoneNo = null;
			this.referralModal = false;
		},
		inviteJeet11User() {
			const isInvalidPhone = !/^\d{10}$/g.test(this.jeet11UserPhoneNo);

			if (isInvalidPhone) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Please enter valid 10 digit phone number!"
				});
				return;
			} else {
				const phoneNoToShare = "91" + this.jeet11UserPhoneNo;
				const linkToBeShared =
					"https://www.jeet11.com/redirect/https%3A%2F%2Fwww.jeet11.com%3Freferrer%3DreferralShareReferralPage%26refCode%3D" +
					this.slicePhoneNo(this.jeet11PartnerPhoneNo);
				const textToBeShared =
					`I have gifted you Rs 50 to start playing on Jeet11\n` +
					`Use my invite code ${this.slicePhoneNo(
						this.jeet11PartnerPhoneNo
					)}\n` +
					`See you on the other side\n`;
				shareOnWhatsapp(linkToBeShared, textToBeShared, phoneNoToShare);
				EventsManager.sendEvent({
					name: "REFERRAL_JEET11USER_CLICKED"
				});
				this.closeReferralModal();
			}
		},
		slicePhoneNo(phoneNo) {
			return phoneNo ? phoneNo.toString().slice(2) : phoneNo;
		},
		fetchMonthlyCommission() {
			if (!this.fetchingMonthlyCommission) {
				this.fetchingMonthlyCommission = true;
				this.$store
					.dispatch(FETCH_MONTHLY_COMMISSION.dispatch)
					.catch(() => {})
					.then(() => {
						this.fetchingMonthlyCommission = false;
					});
			}
		},
		fetchRetailSalary() {
			const date = new Date();
			const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
			const endDate = new Date(
				date.getFullYear(),
				date.getMonth() + 1,
				0
			);
			this.$store
				.dispatch(FETCH_RETAIL_SALARY.dispatch, {
					startDate: new Date(startDate.getTime() + 330 * 60000)
						.toISOString()
						.substr(0, 10),
					endDate: new Date(endDate.getTime() + 330 * 60000)
						.toISOString()
						.substr(0, 10),
					appType: this.isRummyOptionSelected ? "RUMMY" : "JEET11"
				})
				.catch(() => {})
				.then(data => {
					this.retailSalaryData = data;
				});
		}
	},
	watch: {
		isMojAgencyCombinedCheck(newVal) {
			const [newPropertyA, newPropertyB] = newVal.split("|");
			if (Boolean(newPropertyA) && Boolean(newPropertyB)) {
				this.getAgencyInviteAccess();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.amount-wrapper {
	font-weight: 500;
	font-size: 16px;
	display: flex;
	align-items: center;
}
.amount-sign {
	font-size: 20px;
	line-height: 28px;
	color: black;
	opacity: 0.6;
	padding-right: 0.1em;
}

.main-card {
	border-radius: 24px 24px 0px 0px;
	margin-top: 2em;
	color: #575f6b;
}
.top-card {
	padding: 2em 1em;
	color: #fff;
}
.menu-card {
	color: #2b3674;
	font-size: 18px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.75em;
	cursor: pointer;
	margin-bottom: 15px;
	border-radius: 12px;
	box-shadow: none;
	border: transparent;
}
.card-header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
.rounded-lg {
	border-radius: 16px;
}
.transaction-card {
	border-radius: 8px;
}
.transaction-card > .bottom-part {
	font-size: 16px;
	font-weight: 500;
	display: grid;
	align-items: center;
	padding: 16px;
}
.transaction-card > .header {
	color: white;
	text-transform: uppercase;
	font-size: 18px;
	padding: 8px;
	font-weight: 600;
	text-align: center;
}
.success {
	background: green;
}
.failure {
	background: red;
}
.vertical-divider {
	border: 1px solid;
	border-image-source: linear-gradient(
		270deg,
		rgba(255, 255, 255, 0) 0%,
		#ffffff 51.59%,
		rgba(255, 255, 255, 0) 100%
	);
	opacity: 0.5;
	transform: rotate(90deg);
	margin: 0px 0px;
	width: 56px;
	height: 0px;
}
.app-logo {
	height: 80px;
	object-fit: contain;
}
.flex-wrap {
	flex-wrap: wrap;
}
.credits-col {
	margin: 8px;
	margin-left: 0;
	&:last-of-type {
		margin-bottom: 0;
	}
}
.welcome-message {
	font-size: 24px;
	margin: 5px 0px 15px 5px;
	font-weight: 500;
}
.tile-container {
	display: flex;
	justify-content: space-between;
	gap: 10px;
}
.w-full {
	width: 100%;
}
.fz-12 {
	font-size: 12px;
}
.tile-card {
	padding: 15px 18px 15px 18px;
	cursor: pointer;
	margin-top: 15px;
	width: 100%;
	border-radius: 12px;
	margin-bottom: 15px;
	box-shadow: none;
	border: transparent;
	display: flex;
	flex-direction: column;
}
.tile-heading {
	font-size: 18px;
	color: #a3aed0;
	margin-bottom: 12px;
	line-height: 18px;
}
.tile-number {
	font-size: 32px;
	color: #2b3674;
	line-height: 32px;
	font-weight: bold;
}
.tile-subtitle {
	font-size: 14px;
	color: #ff6961;
	font-weight: bold;
	line-height: 18px;
}
.underline-none {
	text-decoration: none;
}
.bdrs-12 {
	border-radius: 12px;
}
</style>
